import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { mockGadgetSubmissions } from '../../data/mockData';
import { Search, Filter, Eye, ShieldCheck, X } from 'lucide-react';
import { GadgetSubmission } from '../../types';
const GadgetStatusBadge = ({
  status
}: {
  status: string;
}) => {
  switch (status) {
    case 'draft':
      return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-slate-100 text-slate-800" data-id="element-534">
          খসড়া
        </span>;
    case 'submitted':
      return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800" data-id="element-535">
          জমাদান করা হয়েছে
        </span>;
    case 'approved':
      return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-536">
          অনুমোদিত
        </span>;
    case 'returned':
      return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-amber-100 text-amber-800" data-id="element-537">
          ফেরত
        </span>;
    case 'published':
      return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-teal-100 text-teal-800" data-id="element-538">
          প্রকাশিত
        </span>;
    default:
      return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-slate-100 text-slate-800" data-id="element-539">
          {status}
        </span>;
  }
};
export const DsSubmissionList: React.FC = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [viewModalData, setViewModalData] = useState<GadgetSubmission | null>(null);
  const filteredSubmissions = mockGadgetSubmissions.filter(sub => {
    const matchesSearch = sub.id.toLowerCase().includes(searchTerm.toLowerCase()) || sub.district.toLowerCase().includes(searchTerm.toLowerCase()) || sub.upazila.toLowerCase().includes(searchTerm.toLowerCase()) || sub.submittedBy.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = statusFilter ? sub.status === statusFilter : true;
    return matchesSearch && matchesStatus;
  });
  const ViewModal = ({
    data
  }: {
    data: GadgetSubmission;
  }) => <div className="space-y-6" data-id="element-540">
      <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-541">
        <div data-id="element-542">
          <p className="text-xs text-slate-500" data-id="element-543">গেজেট আইডি</p>
          <p className="font-medium" data-id="element-544">{data.id}</p>
        </div>
        <div data-id="element-545">
          <p className="text-xs text-slate-500" data-id="element-546">স্ট্যাটাস</p>
          <GadgetStatusBadge status={data.status} data-id="element-547" />
        </div>
        <div data-id="element-548">
          <p className="text-xs text-slate-500" data-id="element-549">অবস্থান</p>
          <p className="font-medium" data-id="element-550">
            {data.district}, {data.upazila}
          </p>
        </div>
        <div data-id="element-551">
          <p className="text-xs text-slate-500" data-id="element-552">জমাদানকারী</p>
          <p className="font-medium" data-id="element-553">{data.submittedBy}</p>
        </div>
        <div data-id="element-554">
          <p className="text-xs text-slate-500" data-id="element-555">তারিখ</p>
          <p className="font-medium" data-id="element-556">
            {new Date(data.submittedAt).toLocaleDateString('bn-BD')}
          </p>
        </div>
        {data.smarakNo && <div data-id="element-557">
            <p className="text-xs text-slate-500" data-id="element-558">স্মারক নং</p>
            <p className="font-medium text-indigo-700" data-id="element-559">{data.smarakNo}</p>
          </div>}
      </div>

      <div className="border border-slate-200 rounded-md overflow-hidden" data-id="element-560">
        <div className="bg-slate-100 px-4 py-2 border-b border-slate-200 font-medium text-sm text-slate-700" data-id="element-561">
          মৌজা ও খতিয়ান তথ্য
        </div>
        <div className="overflow-x-auto" data-id="element-562">
          <table className="min-w-full divide-y divide-slate-200" data-id="element-563">
            <thead className="bg-slate-50" data-id="element-564">
              <tr data-id="element-565">
                <th className="px-3 py-2 text-left text-xs font-medium text-slate-500" data-id="element-566">
                  মৌজার নাম
                </th>
                <th className="px-3 py-2 text-left text-xs font-medium text-slate-500" data-id="element-567">
                  জে.এল. নম্বর
                </th>
                <th className="px-3 py-2 text-left text-xs font-medium text-slate-500" data-id="element-568">
                  শুরু নং
                </th>
                <th className="px-3 py-2 text-left text-xs font-medium text-slate-500" data-id="element-569">
                  শেষ নং
                </th>
                <th className="px-3 py-2 text-left text-xs font-medium text-slate-500" data-id="element-570">
                  খতিয়ান সংখ্যা
                </th>
                <th className="px-3 py-2 text-left text-xs font-medium text-slate-500" data-id="element-571">
                  শীট সংখ্যা
                </th>
                <th className="px-3 py-2 text-left text-xs font-medium text-slate-500" data-id="element-572">
                  মন্তব্য
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-slate-200" data-id="element-573">
              {data.moujaDetails.map((row, index) => <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-slate-50'} data-id="element-574">
                  <td className="px-3 py-2 text-sm text-slate-700" data-id="element-575">
                    {row.mouja}
                  </td>
                  <td className="px-3 py-2 text-sm text-slate-700" data-id="element-576">
                    {row.jlNumber}
                  </td>
                  <td className="px-3 py-2 text-sm text-slate-700" data-id="element-577">
                    {row.khatianStartNo || '—'}
                  </td>
                  <td className="px-3 py-2 text-sm text-slate-700" data-id="element-578">
                    {row.khatianEndNo || '—'}
                  </td>
                  <td className="px-3 py-2 text-sm text-slate-700" data-id="element-579">
                    {row.totalKhatian}
                  </td>
                  <td className="px-3 py-2 text-sm text-slate-700" data-id="element-580">
                    {row.totalSheet}
                  </td>
                  <td className="px-3 py-2 text-sm text-slate-700" data-id="element-581">
                    {row.remarks || '—'}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
  return <div className="max-w-7xl mx-auto" data-id="element-582">
      <div className="mb-6" data-id="element-583">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-584">
          গেজেট জমাদান তালিকা (ডিএস)
        </h1>
        <p className="text-slate-500" data-id="element-585">
          সকল জোনাল সেটেলমেন্ট অফিস থেকে প্রাপ্ত গেজেট জমাদান দেখুন
        </p>
      </div>

      <div className="card overflow-hidden flex flex-col h-[calc(100vh-12rem)]" data-id="element-586">
        <div className="p-4 border-b border-slate-200 bg-slate-50 flex space-x-4" data-id="element-587">
          <div className="relative flex-1 max-w-md" data-id="element-588">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400" size={18} data-id="element-589" />
            <input type="text" placeholder="আইডি, অবস্থান বা জমাদানকারী দিয়ে অনুসন্ধান..." className="input-field pl-10 text-sm" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-590" />
          </div>
          <select className="input-field w-48 text-sm" value={statusFilter} onChange={e => setStatusFilter(e.target.value)} data-id="element-591">
            <option value="" data-id="element-592">সকল স্ট্যাটাস</option>
            <option value="submitted" data-id="element-593">জমাদান করা হয়েছে</option>
            <option value="approved" data-id="element-594">অনুমোদিত</option>
            <option value="returned" data-id="element-595">ফেরত</option>
            <option value="published" data-id="element-596">প্রকাশিত</option>
          </select>
          <button className="btn-secondary flex items-center text-sm" data-id="element-597">
            <Filter size={16} className="mr-2" data-id="element-598" /> আরও ফিল্টার
          </button>
        </div>

        <div className="flex-1 overflow-auto" data-id="element-599">
          <table className="min-w-full divide-y divide-slate-200" data-id="element-600">
            <thead className="bg-slate-50 sticky top-0 z-10" data-id="element-601">
              <tr data-id="element-602">
                <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase" data-id="element-603">
                  আইডি
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase" data-id="element-604">
                  জেলা
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase" data-id="element-605">
                  উপজেলা
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase" data-id="element-606">
                  মৌজা সংখ্যা
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase" data-id="element-607">
                  জমাদানকারী
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase" data-id="element-608">
                  তারিখ
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase" data-id="element-609">
                  স্ট্যাটাস
                </th>
                <th className="px-4 py-3 text-right text-xs font-medium text-slate-500 uppercase" data-id="element-610">
                  কার্যক্রম
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-slate-200" data-id="element-611">
              {filteredSubmissions.map(sub => <tr key={sub.id} className="hover:bg-slate-50" data-id="element-612">
                  <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-slate-900" data-id="element-613">
                    {sub.id}
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap text-sm text-slate-600" data-id="element-614">
                    {sub.district}
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap text-sm text-slate-600" data-id="element-615">
                    {sub.upazila}
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap text-sm text-slate-500" data-id="element-616">
                    {sub.moujaDetails.length}
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap text-sm text-slate-500" data-id="element-617">
                    {sub.submittedBy}
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap text-sm text-slate-500" data-id="element-618">
                    {new Date(sub.submittedAt).toLocaleDateString('bn-BD')}
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap" data-id="element-619">
                    <GadgetStatusBadge status={sub.status} data-id="element-620" />
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap text-right text-sm font-medium space-x-2" data-id="element-621">
                    <button onClick={() => setViewModalData(sub)} className="text-blue-600 hover:text-blue-900 p-1 bg-blue-50 rounded" title="দেখুন" data-id="element-622">
                      <Eye size={16} data-id="element-623" />
                    </button>
                    {sub.status === 'submitted' && <button onClick={() => navigate('/gadget/approve')} className="text-indigo-600 hover:text-indigo-900 p-1 bg-indigo-50 rounded" title="অনুমোদন করুন" data-id="element-624">
                        <ShieldCheck size={16} data-id="element-625" />
                      </button>}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>

      {viewModalData && <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-id="element-626">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] flex flex-col" data-id="element-627">
            <div className="p-4 border-b border-slate-200 flex justify-between items-center bg-slate-50 rounded-t-lg" data-id="element-628">
              <h2 className="text-lg font-bold text-slate-800" data-id="element-629">
                গেজেট দেখুন — {viewModalData.id}
              </h2>
              <button onClick={() => setViewModalData(null)} className="text-slate-400 hover:text-slate-600" data-id="element-630">
                <X size={20} data-id="element-631" />
              </button>
            </div>
            <div className="p-6 overflow-y-auto flex-1" data-id="element-632">
              <ViewModal data={viewModalData} data-id="element-633" />
            </div>
            <div className="p-4 border-t border-slate-200 bg-slate-50 rounded-b-lg flex justify-end" data-id="element-634">
              <button onClick={() => setViewModalData(null)} className="btn-secondary" data-id="element-635">
                বন্ধ করুন
              </button>
            </div>
          </div>
        </div>}
    </div>;
};